import { directive as vClickOutside } from 'vue-clickaway'
import VTooltip from 'v-tooltip'
import { Loading } from 'element-ui';

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install (Vue) {
    Vue.directive('click-outside', vClickOutside)
    Vue.use(VTooltip)
    Vue.use(Loading.directive);
  }
}

export default GlobalDirectives
